const { io } = require('./ioHandler');

function incrementCounterValue(stat, labelValue) {
  
  io.emit(`frontendMetrics:counter:increment:${stat}`, {
    labelValue,
  });
}

function observeHistogramMetric(stat, value, labelValue) {
  io.emit(`frontendMetrics:histogram:observe:${stat}`, {
    value,
    labelValue,
  });
}

module.exports = {
  incrementCounterValue,
  observeHistogramMetric
};
